import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import AmazonLockerWidget from "../FormComponents/AmazonLockerWidget";
import Product from "../Pages/QueueDetail/Product";
import {addressConfigAlwaysCompany} from "./components/address";
import {addressConfigB2bAutocomplete} from "./components/address_b2b";

export const orderEntryConfigAmazonLocker = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ]
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.productSelection">Product selection</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "productselect"
                },
                {
                    "name": "orderattributes.field_service_code",
                    "label": "Field Service Code (e.g. V1368564863)",
                    "size": "half",
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product));

                        return product?.number === "Gen3";
                    },
                },
                {
                    "name": "orderattributes.pin_code",
                    "label": "PIN Code (e.g. 7BIZN1)",
                    "size": "half",
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product));

                        return product?.number === "Gen3";
                    },
                },
            ],
            "conditionFunction": values => !!values.requesttype
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.customerReference.label">Customer references</Trans></h2>,
            "fields": [
                {
                    "name": "orderattributes.case_id",
                    "label": "Case ID",
                    "size": "full",
                    "required": true,
                },
                {
                    "name": "orderattributes.intervention_id",
                    "label": "Intervention ID",
                    "size": "full",
                    "required": true,
                },
                {
                    "name": "orderattributes.kiosk_id",
                    "label": "Kiosk ID",
                    "size": "half",
                    "required": true,
                },
                {
                    "name": "orderattributes.service_code",
                    "label": "Service Code",
                    "size": "half",
                    "type": "number",
                    "validatetype": "serviceCodeAmazonLocker",
                    "required": true,
                },
                {
                    "name": "orderattributes.locker_service_type",
                    "label": "Locker Service Type",
                    "size": "full",
                    "type": "select",
                    "required": true,
                    "options": [
                        {
                            "value": "Certificate rotation",
                            "label": "Certificate rotation"
                        },
                        {
                            "value": "Cleaning",
                            "label": "Cleaning"
                        },
                        {
                            "value": "DGUV",
                            "label": "DGUV"
                        },
                        {
                            "value": "Electrician Support",
                            "label": "Electrician Support"
                        },
                        {
                            "value": "Greasing",
                            "label": "Greasing"
                        },
                        {
                            "value": "Intervention 4h",
                            "label": "Intervention 4h"
                        },
                        {
                            "value": "Intervention NBD",
                            "label": "Intervention NBD"
                        },
                        {
                            "value": "Intervention Weekend",
                            "label": "Intervention Weekend"
                        },
                        {
                            "value": "On-Site Audit",
                            "label": "On-Site Audit"
                        },
                        {
                            "value": "Sweep",
                            "label": "Sweep"
                        }
                    ],
                },
                {
                    "name": "orderattributes.job_requested_date",
                    "label": "Job Requested Date",
                    "size": "full",
                    "type": "datetimepicker",
                    "allowPast": true,
                    "required": true,
                },
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.addressContact">Address & contact information</Trans></h2>,
            "fields": [
                ...addressConfigB2bAutocomplete,
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
        {
            "fields": [
            ],
            "conditionFunction": values => !!values.requesttype
        },
        {
            "heading": <h2><Trans i18nKey="queueDetail.appointment.label">Appointment</Trans></h2>,
            "fields": [
                {
                    "name": "orderattributes.sla",
                    "label": "SLA",
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "full",
                    "type": "select",
                    "options": [
                        {
                            "value": "4hr",
                            "label": "4hr"
                        },
                        {
                            "value": "10 BD",
                            "label": "10 BD"
                        },
                        {
                            "value": "15 BD",
                            "label": "15 BD"
                        },
                        {
                            "value": "next BD",
                            "label": "next BD"
                        },
                        {
                            "value": "Other",
                            "label": "Other"
                        }
                    ],
                    "required": true,
                },
                {
                    "name": "appointment_date",
                    "label": <Trans i18nKey="queueDetail.appointment.label">Scheduled Date</Trans>,
                    "size": "full",
                    "type": "datepicker",
                },
                {
                    size: "full",
                    name: "amazonlockerwidget",
                    component: "amazonlockerwidget",
                },
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.notes.label">Notes</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.notes.description"></Trans>,
            "fields": [
                {
                    "size": "full",
                    "key": "notes",
                    "name": "notes",
                    "label": <Trans i18nKey="queueDetail.notes.label">Notes</Trans>,
                    "multiline": true,
                },
            ],
            "conditionFunction": values => !!values.requesttype && values.product
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": values => !!values.requesttype  && values.product
                }
            ],
        }
    ]
}
